import { jsx as _jsx } from "react/jsx-runtime";
import svgTapestryBehindRight from './svgs/tapestry-behind-right.svg?url';
export function TapestryBehindRight(props) {
    return (_jsx("svg", { ...props, fill: "none", viewBox: "0 0 951 609", children: _jsx("use", { href: `${svgTapestryBehindRight}#tapestry-behind-right` }) }));
}
